import {LitElement} from "lit";
import {Initializing} from "../../../common/elements";
import {ManagingResources} from "../../../common/lifetime";
import {property} from "lit/decorators.js";
import {type DialogOpener, DialogOpenerFactory} from "./dialogOpener";
import {resolve} from "../../../container";

export abstract class DialogAnchorElementContent extends Initializing(ManagingResources(LitElement)) {

    @property({attribute: "disable-close-on-outside-click", type: Boolean})
    public disableCloseOnOutsideClick: boolean = false;

    @property({attribute: "active-from-breakpoint", type: String})
    public activeFromBreakpoint: string = "xs";

    private dialogOpenerFactory: DialogOpenerFactory = resolve(DialogOpenerFactory);
    private dialogOpener: DialogOpener;

    public createDialog(dialogContent: HTMLElement): void {
        this.dialogOpener = this.dialogOpenerFactory.createWithAnchor(dialogContent, this, this.activeFromBreakpoint, this.disableCloseOnOutsideClick);
    }

    public openDialog(e: Event): void {
        this.dialogOpener.openDialog(e);
    }
}
